<div class="dashboard-container">
    <div class="dashboard-wrapper">
        <div class="top-section">
            <div class="left-section">
                <div class="logo-section-container">
                    <mat-icon svgIcon="arrowleft" (click)="goBack()" class="back-icon"></mat-icon>
                    <a class="logo-section" routerLink="/home">
                        <img src="../../../assets/images/funfigz-logo.png" class="logo-image" alt="Logo" />
                    </a>
                </div>

                <div class="section">
                    <p class="title">Account</p>
                    <div class="item-section">
                        <p class="item" routerLinkActive="active-link" routerLink="/account/overview">
                            <mat-icon svgIcon="home" class="menu-icon"></mat-icon>
                            Overview
                        </p>
                        <p class="item" routerLinkActive="active-link" routerLink="/account/trackOrder">
                            <mat-icon svgIcon="order" class="menu-icon"></mat-icon>
                            Order & Status
                        </p>
                        <p class="item" routerLinkActive="active-link" routerLink="/account/rewards">
                            <mat-icon svgIcon="starborder" class="menu-icon"></mat-icon>
                            Rewards
                        </p>
                        <p class="item" routerLinkActive="active-link" routerLink="/wishlist">
                            <mat-icon svgIcon="wishlist" class="menu-icon"></mat-icon>
                            My wishlist
                        </p>
                        <p class="item" routerLinkActive="active-link" routerLink="/account/myStructures">
                            <mat-icon svgIcon="structure" class="structure-icon"></mat-icon>
                            My Structures
                        </p>
                    </div>
                </div>

                <div class="section">
                    <p class="title">Profile</p>
                    <div class="item-section">
                        <p class="item" routerLinkActive="active-link" routerLink="/account/profileDetails">
                            <mat-icon svgIcon="user" class="menu-icon"></mat-icon>
                            Profile Details
                        </p>
                        <p class="item" routerLinkActive="active-link" routerLink="/account/addressDetails">
                            <mat-icon svgIcon="location" class="menu-icon"></mat-icon>
                            Addresses
                        </p>
                    </div>
                </div>

                <div class="section">
                    <p class="title">system</p>
                    <div class="item-section">
                        <p class="item" (click)="logOut()">
                            <mat-icon svgIcon="logout" class="menu-icon"></mat-icon>
                            Logout
                        </p>
                    </div>
                </div>
            </div>

            <div class="right-section">
                <router-outlet></router-outlet>
            </div>
        </div>

        <div class="footer-section">
            <ul>
                <li>
                    <a routerLinkActive="active" routerLink="/home" [routerLinkActiveOptions]="{ exact: true }">
                        <mat-icon svgIcon="home" class="section-icon"></mat-icon>
                        <span class="section-name">Home</span>
                    </a>
                </li>

                <li>
                    <a routerLinkActive="active" routerLink="/products">
                        <mat-icon svgIcon="questionmark" class="section-icon"></mat-icon>
                        <span class="section-name">Shop</span>
                    </a>
                </li>

                <li>
                    <a routerLinkActive="active" routerLink="/account/trackOrder">
                        <mat-icon svgIcon="orderSolid" class="section-icon"></mat-icon>
                        <span class="section-name">Orders</span>
                    </a>
                </li>

                <li>
                    <a routerLinkActive="active" routerLink="/wishlist">
                        <mat-icon svgIcon="activewishlist" class="section-icon"></mat-icon>
                        <span class="section-name">Wishlist</span>
                    </a>
                </li>

                <li>
                    <a routerLinkActive="active" routerLink="/account/overview">
                        <mat-icon svgIcon="userSolid" class="section-icon"></mat-icon>
                        <span class="section-name">Profile</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
